import { render } from "./surveyTemplateCustomizer.vue?vue&type=template&id=66b29eae&scoped=true&ts=true"
import script from "./surveyTemplateCustomizer.vue?vue&type=script&lang=ts"
export * from "./surveyTemplateCustomizer.vue?vue&type=script&lang=ts"

import "./surveyTemplateCustomizer.vue?vue&type=style&index=0&id=66b29eae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b29eae"]])

export default __exports__